import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
// APIモジュール
import API, { graphqlOperation } from "@aws-amplify/api";
import * as queries from "../graphql/queries";
import * as mutations from "../graphql/mutations";

// フォームコンポーネント
import { useFormik } from "formik";
import * as Yup from "yup";

import ReactJson from "react-json-view";

import {
  Container,
  TextField,
  Button,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableContainer,
  Typography,
  Link,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
} from "@material-ui/core";
import { StyledTableCell, StyledTableRow } from "../modules/modules";
import { makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";

if (process.env.NODE_ENV === "development") {
  var base_url = "http://localhost:3000";
} else if (process.env.NODE_ENV === "production") {
  base_url = "https://new.pluselect.com";
}
const api_name = process.env.REACT_APP_API_NAME;

const useStyles = makeStyles((theme) => ({
  interval: {
    marginTop: theme.spacing(5),
  },
  field: {
    width: "100%",
    alignItems: "center",
  },
  textField: {
    width: "100%",
  },
  button: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    display: "flex",
  },
}));

export default function Admin(props) {
  const userGroup = props.userGroup;
  const classes = useStyles();
  const history = useHistory();
  const [userInfo, setUserInfo] = useState({});
  const [userProfile, setUserProfile] = useState({});
  const [userShop, setUserShop] = useState([]);
  const [userBuyma, setUserBuyma] = useState([]);
  const [userOrder, setUserOrder] = useState([]);
  const [portalUrl, setPortalUrl] = useState("");
  const [exhibition, setExhibition] = useState([]);
  const [stripeAccount, setStripeAccount] = useState([]);
  const [childUser, setChildUser] = useState([]);

  useEffect(() => {
    // 管理者のみ
    if (!userGroup.includes("Administrator")) {
      console.log("管理者のみ");
      history.push("/");
      return;
    } else if (stripeAccount.length === 0) {
      // Stripeアカウント取得
      var query = {
        body: {
          limit: 200,
        },
      };
      API.post(api_name, "/stripe/listAccounts", query)
        .then((res) => {
          console.log(res);
          if (res) {
            let newList = res.data.map((res) => {
              let name = "";
              if (res.business_profile.name) {
                name = res.business_profile.name;
              } else {
                name = res.email;
              }
              res["name"] = name;
              return res;
            });
            setStripeAccount(newList);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);

  useEffect(() => {
    if (userInfo) {
      console.log(userInfo);
      var customerId = userInfo.customerId;
      if (customerId && !portalUrl) {
        createPortalSession(customerId);
      }
    }
  }, [userInfo]);

  const handleChange = function (e) {
    let id = e.target.id;
    let value = e.target.value;
    if (id === "userId" && value) {
      if (value.match(/-/g).length === 4) {
        getUserInfo({ id: value }).then((userInfo) => {
          handleUserInfo(userInfo);
        });
      }
    } else if (id === "email") {
      console.log(value);
    }
  };

  const handleSearch = function (e) {
    if (e === "email") {
      // メールアドレスでユーザー情報を検索
      let filter = {
        email: {
          eq: document.getElementById("email").value,
        },
      };
      listUserInfos(filter).then((res) => {
        if (res.length !== 0) {
          handleUserInfo(res[0]);
        }
      });
    } else if (e) {
      // stripeアカウントで検索
      console.log(e);
      listUserInfosBySpecificStripeParentAccount(e).then((res) => {
        setChildUser(res);
      });
    }
  };

  const handleSearchExhibition = async function () {
    const kaiinId = Number(document.getElementById("kaiinId").value);
    const limit = Number(document.getElementById("limit").value);
    const syuppin = Number(document.getElementById("syuppin").value);
    const changeSyuppin = Number(
      document.getElementById("changeSyuppin").value
    );

    let filter = {};
    if (syuppin === 1) {
      filter["syuppin"] = {
        eq: true,
      };
    } else if (syuppin === 0) {
      filter["syuppin"] = {
        eq: false,
      };
    }
    let nextToken = null;
    let loop = true;
    let exhibitionList = [];
    while (loop) {
      let listData = await listExhibitionsBySpecificKaiinId(
        kaiinId,
        filter,
        limit,
        nextToken
      );
      exhibitionList = exhibitionList.concat(listData.items);
      nextToken = listData.nextToken;
      if (!nextToken || limit) {
        loop = false;
      }
    }
    console.log(exhibitionList);
    setExhibition(exhibitionList);

    let editSyuppin = true;
    if (changeSyuppin === 1) {
      editSyuppin = true;
    } else if (changeSyuppin === 0) {
      editSyuppin = false;
    } else {
      return;
    }
    exhibitionList.map((exhibition) => {
      if (!exhibition.syuppin) {
        const input = {
          id: exhibition.id,
          syuppin: editSyuppin,
        };
        API.graphql({
          query: mutations.updateExhibition,
          variables: { input: input },
        })
          .then((res) => {
            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  const listExhibitionsBySpecificKaiinId = async (
    kaiinId,
    filter,
    limit,
    nextToken
  ) => {
    let queryParam = {
      kaiinId: kaiinId,
      sortDirection: "DESC",
      limit: limit ? limit : 1000,
      nextToken: nextToken,
    };
    if (filter) queryParam["filter"] = filter;
    console.log(queryParam);
    let response = await API.graphql(
      graphqlOperation(queries.listExhibitionsBySpecificKaiinId, queryParam)
    );
    let listData = response.data.listExhibitionsBySpecificKaiinId;
    return listData;
  };

  const handleUserInfo = function (userInfo) {
    if (userInfo) {
      setUserInfo(userInfo);
      setUserProfile(userInfo.profile);
      setUserBuyma(userInfo.buyma.items);
      setUserOrder(userInfo.order.items);
      setUserShop(userInfo.shop.items);
      if (userInfo.stripeAccount) {
        listUserInfosBySpecificStripeParentAccount(userInfo.stripeAccount).then(
          (res) => {
            setChildUser(res);
          }
        );
      }
    }
  };

  const getUserInfo = (variables) => {
    return new Promise(function (resolve, reject) {
      API.graphql({
        query: queries.getUserInfo,
        variables: variables,
        nullable: true,
      })
        .then((res) => {
          resolve(res.data.getUserInfo);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const listUserInfos = (filter) => {
    return new Promise(function (resolve, reject) {
      API.graphql({
        query: queries.listUserInfos,
        variables: { filter: filter },
      })
        .then((res) => {
          resolve(res.data.listUserInfos.items);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const createPortalSession = function (customerId) {
    var query = {
      body: {
        return_url: base_url,
        customerId: customerId,
      },
    };
    API.post(api_name, "/stripe/createCustomerPortalSession", query)
      .then((response) => {
        console.log(response);
        if (response.url) {
          console.log(response.url);
          setPortalUrl(response.url);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Graphqlレコード登録処理
  const handleDeleteUserBuyma = (id) => {
    var input = {
      id: id,
    };
    API.graphql({
      query: mutations.deleteUserBuyma,
      variables: { input: input },
    })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDeleteUserShop = (id) => {
    console.log(id);
    var input = {
      id: id,
    };
    API.graphql({
      query: mutations.deleteUserShop,
      variables: { input: input },
    })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleUpdateUserInfo = (values) => {
    console.log(values);
    let input = {
      id: userInfo.id,
      stripeParentAccount: values.stripeParentAccount,
    };
    API.graphql({
      query: mutations.updateUserInfo,
      variables: { input: input },
    })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const listUserInfosBySpecificStripeParentAccount = (stripeParentAccount) => {
    return new Promise(function (resolve, reject) {
      API.graphql(
        graphqlOperation(queries.listUserInfosBySpecificStripeParentAccount, {
          stripeParentAccount: stripeParentAccount,
          limit: 100,
        })
      )
        .then((res) => {
          resolve(res.data.listUserInfosBySpecificStripeParentAccount.items);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const formik = useFormik({
    initialValues: {
      stripeParentAccount: "",
    },
    onSubmit: (values) => {
      handleUpdateUserInfo(values);
    },
    validationSchema: Yup.object().shape({
      stripeParentAccount:
        Yup.string().required("stripe親アカウントは必須です。"),
    }),
  });

  return (
    <React.Fragment>
      <Container className={classes.interval}>
        <Typography variant="h2" align="center" gutterBottom>
          ユーザー検索
        </Typography>

        <TableContainer>
          <Table stickyHeader>
            <TableBody>
              <StyledTableRow>
                <StyledTableCell align="left" variant="head" width="50%">
                  <TextField
                    id="userId"
                    label="ユーザーID"
                    type="text"
                    className={classes.textField}
                    onChange={(e) => handleChange(e)}
                  />
                </StyledTableCell>
                <StyledTableCell align="left">{userProfile.id}</StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
          <Table stickyHeader>
            <TableBody>
              <StyledTableRow>
                <StyledTableCell align="left" variant="head" width="50%">
                  <TextField
                    id="email"
                    label="メールアドレス"
                    type="text"
                    className={classes.textField}
                  />
                </StyledTableCell>
                <StyledTableCell align="left">
                  <Button
                    variant="outlined"
                    onClick={() => handleSearch("email")}
                    className={classes.field}
                  >
                    検索
                  </Button>
                </StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Button
          variant="contained"
          className={classes.field}
          disabled={!portalUrl}
          href={portalUrl}
        >
          決済情報を確認
        </Button>
      </Container>

      <Container className={classes.interval}>
        <Typography variant="h2" align="center" gutterBottom>
          Stripe情報
        </Typography>
        <TableContainer>
          <Table stickyHeader>
            <TableBody>
              <StyledTableRow>
                <StyledTableCell align="left" variant="head" width="200">
                  Stripeアカウント
                </StyledTableCell>
                <StyledTableCell align="left">
                  {userInfo.stripeAccount}
                </StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell align="left" variant="head" width="200">
                  Stripe親アカウント
                </StyledTableCell>
                <StyledTableCell align="left">
                  {userInfo.stripeParentAccount}
                </StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <form onSubmit={formik.handleSubmit}>
          <FormControl className={classes.formControl}>
            <InputLabel>stripeアカウント</InputLabel>
            <Select
              name="stripeParentAccount"
              {...formik.getFieldProps("stripeParentAccount")}
            >
              {stripeAccount.map((e) => (
                <MenuItem value={e.id} key={e.id}>
                  {e.name} - {e.id}
                </MenuItem>
              ))}
            </Select>
            {formik.touched.stripeParentAccount &&
            formik.errors.stripeParentAccount ? (
              <Typography variant="caption" color="error">
                {formik.errors.stripeParentAccount}
              </Typography>
            ) : null}
          </FormControl>
          <Button
            className={classes.button}
            variant="contained"
            type="submit"
            disabled={!formik.isValid || !userInfo.id}
          >
            stripe親アカウントに登録
          </Button>
          <Button
            className={classes.button}
            variant="contained"
            disabled={!formik.isValid}
            onClick={() => handleSearch(formik.values.stripeParentAccount)}
          >
            stripeアカウントで検索
          </Button>
        </form>
      </Container>

      <Container className={classes.interval}>
        <Typography variant="h2" align="center" gutterBottom>
          子供ユーザー
        </Typography>
        <TableContainer>
          <Table stickyHeader>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell align="left">ID</StyledTableCell>
                <StyledTableCell align="left">メールアドレス</StyledTableCell>
                <StyledTableCell align="left">名前</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {childUser.map((data) => {
                return (
                  <StyledTableRow key={data.id}>
                    <StyledTableCell align="left">{data.id}</StyledTableCell>
                    <StyledTableCell align="left">{data.email}</StyledTableCell>
                    <StyledTableCell align="left">
                      {data.profile.name}
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      <Container className={classes.interval}>
        <Typography variant="h2" align="center" gutterBottom>
          プロフィール
        </Typography>
        <TableContainer>
          <Table stickyHeader>
            <TableBody>
              <StyledTableRow>
                <StyledTableCell align="left" variant="head" width="200">
                  名前
                </StyledTableCell>
                <StyledTableCell align="left">
                  {userProfile.name}
                </StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell align="left" variant="head" width="200">
                  電話番号
                </StyledTableCell>
                <StyledTableCell align="left">
                  {userProfile.phone}
                </StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell align="left" variant="head" width="200">
                  住所
                </StyledTableCell>
                <StyledTableCell align="left">
                  {userProfile.address}
                </StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      <Container className={classes.interval}>
        <Typography variant="h2" align="center" gutterBottom>
          ショップリスト
        </Typography>
        <TableContainer>
          <Table stickyHeader>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell align="left">ショップ名</StyledTableCell>
                <StyledTableCell align="left">リンク</StyledTableCell>
                <StyledTableCell align="left">削除</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {userShop.map((data) => {
                return (
                  <StyledTableRow key={data.id}>
                    <StyledTableCell align="left">
                      {data.shop.name}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Link color="textSecondary" href={data.shop.link}>
                        {data.shop.link}
                      </Link>
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <IconButton
                        color="secondary"
                        onClick={() => handleDeleteUserShop(data.id)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      <Container className={classes.interval}>
        <Typography variant="h2" align="center" gutterBottom>
          BUYMAアカウントリスト
        </Typography>
        <TableContainer>
          <Table stickyHeader>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell align="left">
                  BUYMAアカウント名
                </StyledTableCell>
                <StyledTableCell align="left">会員ID</StyledTableCell>
                <StyledTableCell align="left">ステータス</StyledTableCell>
                <StyledTableCell align="left">削除</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {userBuyma.map((data) => {
                return (
                  <StyledTableRow key={data["id"]}>
                    <StyledTableCell align="left">{data.buyma}</StyledTableCell>
                    <StyledTableCell align="left">
                      {data.kaiinId}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      {data.approved === 1 ? "有効" : "無効"}
                      {data.subAccount ? "【サブアカウント】" : null}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <IconButton
                        color="secondary"
                        onClick={() => handleDeleteUserBuyma(data["id"])}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      <Container className={classes.interval}>
        <Typography variant="h2" align="center" gutterBottom>
          注文リスト
        </Typography>
        <TableContainer>
          <Table stickyHeader>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell align="left">決済ID</StyledTableCell>
                <StyledTableCell align="left">金額</StyledTableCell>
                <StyledTableCell align="left">メタデータ</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {userOrder.map((data) => {
                return (
                  <StyledTableRow key={data["id"]}>
                    <StyledTableCell align="left">{data.id}</StyledTableCell>
                    <StyledTableCell align="left">
                      {data.amount}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      {data.metadata}
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      <Container className={classes.interval}>
        <Typography variant="h2" align="center" gutterBottom>
          出品リスト
        </Typography>
        <TextField
          id="kaiinId"
          label="会員ID"
          type="text"
          className={classes.textField}
        />
        <TextField
          id="limit"
          label="取得数"
          type="number"
          className={classes.textField}
        />
        <TextField
          id="syuppin"
          label="出品中取得しますか？"
          type="number"
          className={classes.textField}
        />
        <Typography variant="body2" gutterBottom>
          出品中のみ:1、停止中のみ:0、それ以外:filterなし
        </Typography>
        <TextField
          id="changeSyuppin"
          label="出品中に変更しますか？"
          type="number"
          className={classes.textField}
        />
        <Typography variant="body2" gutterBottom>
          出品中に変更:1、停止中に変更:0、それ以外:変更なし
        </Typography>
        <Button
          variant="outlined"
          onClick={handleSearchExhibition}
          className={classes.field}
        >
          検索
        </Button>
        <TableContainer className={classes.table}>
          <Table stickyHeader>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell align="left">商品ID</StyledTableCell>
                <StyledTableCell align="left">会員ID</StyledTableCell>
                <StyledTableCell align="left">出品</StyledTableCell>
                <StyledTableCell align="left">変更</StyledTableCell>
                <StyledTableCell align="left">URL</StyledTableCell>
                <StyledTableCell align="left">BUYMAリンク</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {exhibition.map((row) => {
                return (
                  <StyledTableRow key={row.id}>
                    <StyledTableCell>{row.id}</StyledTableCell>
                    <StyledTableCell>{row.kaiinId}</StyledTableCell>
                    <StyledTableCell>
                      {row.syuppin ? "出品中" : "停止中"}
                    </StyledTableCell>
                    <StyledTableCell>
                      {row.change ? "あり" : "なし"}
                    </StyledTableCell>
                    <StyledTableCell>
                      <Link color="textSecondary" href={row.url}>
                        {row.url}
                      </Link>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Link
                        color="textSecondary"
                        href={"https://www.buyma.com/item/" + row.id}
                      >
                        {"https://www.buyma.com/item/" + row.id}
                      </Link>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      <Container className={classes.interval}>
        <Typography variant="h2" align="center" gutterBottom>
          ユーザーの情報
        </Typography>
        <ReactJson
          src={userInfo}
          theme="twilight"
          enableClipboard={false}
          displayObjectSize={false}
          displayDataTypes={false}
          collapseStringsAfterLength={100}
        />
      </Container>

      <Container className={classes.interval}>
        <Typography variant="h2" align="center" gutterBottom>
          Stripe登録アカウント情報
        </Typography>
        <ReactJson
          src={stripeAccount}
          theme="twilight"
          enableClipboard={false}
          displayObjectSize={false}
          displayDataTypes={false}
          collapseStringsAfterLength={100}
        />
      </Container>
    </React.Fragment>
  );
}
